<template>
  <div class="container">
    <van-row class="header" type="flex" justify="space-between">
      <van-col class="head-arrow" @click="goBack"><van-icon name="arrow-left" color="#0b41cd" /></van-col>
    </van-row>
    <div class="bg" />
    <van-tabs
      v-show="showPendingTasks || showCompletedTasks || showPublishedTasks"
      v-model="active"
      class="tab-new"
      @change="tabChange"
    >
      <van-tab v-if="showPendingTasks" title="变更日志" name="changeLog">
        <van-list style="padding: 10px 0.4rem 50px">
          <van-list>
            <van-collapse v-model="activeNames" class="collapse" disabled>
              <template v-if="list.length == 0">
                <p style="text-align: center; color: #969799; font-size: 3.733333vmin">暂无日志</p>
              </template>
              <template v-else>
                <van-collapse-item name="index" v-for="item in list" :key="item.title" :is-link="false" disabled>
                  <template #title>
                    <van-row type="flex" align="center" class="card">
                      <van-col>
                        <van-icon class="iconfont menu-icon" class-prefix="icon" name="menu-yiqi" size="24" />
                      </van-col>
                      <van-row class="name">{{ item.fieldName }}</van-row>
                      <van-col span="10" class="card-text">
                        {{ dayjs(item.updateTime).format('YYYY-MM-DD HH:mm:ss') }}
                      </van-col>
                    </van-row>
                  </template>
                  <div class="collapse-content">
                    <van-row span="24" class="card-line">
                      <van-col class="label">变更前</van-col>
                      <van-col class="value">{{ item.beforeChangeValue }} </van-col>
                    </van-row>
                    <van-row class="card-line">
                      <van-col class="label">变更后</van-col>
                      <van-col class="value">{{ item.afterChangeValue }} </van-col>
                    </van-row>
                    <van-row v-if="isUpdatedUser" class="card-line">
                      <van-col class="label">变更人</van-col>
                      <van-col class="value">{{ item.updatedUser }} </van-col>
                    </van-row>
                  </div>
                </van-collapse-item>
              </template>
            </van-collapse>
          </van-list>
        </van-list>
      </van-tab>
      <van-tab title="反馈历史" name="publishedTasks">
        <published-tasks ref="publishedTasks" :equipmentNum="equipmentNum" />
      </van-tab>
    </van-tabs>
    <div class="empty" v-show="!showPendingTasks && !showCompletedTasks && !showPublishedTasks">暂无可用数据</div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import PublishedTasks from '@/views/task/publishedTasks/publishedTasksForView'
import { getSelectedDealer } from '@/utils/auth'
export default {
  name: 'Task',
  components: { PublishedTasks },
  data() {
    return {
      equipmentNum: '',
      activeNames: ['index'],
      isUpdatedUser: false,
      routeFromName: '',
      active: 'changeLog',
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      total: 0,
      queryParams: {
        pageNum: 0,
        pageSize: 10
      },
      timer: null,
      dealerClone: getSelectedDealer(),
      showCompletedTasks: true,
      showPendingTasks: true,
      showPublishedTasks: true,
      editAble: false
    }
  },
  watch: {
    $route: {
      handler: function (to) {
        // if (to.params.page === 'ST') {
        //   this.active = 'students'
        //   this.$refs.student.onRefresh()
        // } else if (to.params.page === 'Account') {
        //   this.active = 'dealerAccount'
        //   this.$refs.dealerAccount.onRefresh()
        // } else if (to.params.page === 'Contact') {
        //   this.active = 'dealerContact'
        //   this.$refs.dealerContactList.onRefresh()
        // }
      }
    }
  },
  created() {
    this.list = JSON.parse(this.$route.query.data)
    this.equipmentNum = this.$route.query.equipmentNum
    this.isUpdatedUser = this.$route.query.isUpdatedUser ? JSON.parse(this.$route.query.isUpdatedUser) : false
    this.routeFromName = this.$route.query.routeFromName ? JSON.parse(this.$route.query.routeFromName) : ''
    // this.filterTabs()
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    dayjs,
    handleChange() {
      this.activeNames = ['index']
    },
    tabChange() {
      switch (this.active) {
        case 'publishedTasks':
          // this.$refs.publishedTasks.onRefresh()
          break
        case 'completedTasks':
          //  this.$refs.completedTasks.onRefresh()
          break
        case 'pendingTasks':
          //  this.$refs.pendingTasks.onRefresh()
          break
      }
    },
    filterTabs() {
      const menus = this.$store.state.user.routes
      this.showCompletedTasks = menus.includes('已办任务')
      this.showPendingTasks = menus.includes('待办任务')
      this.showPublishedTasks = menus.includes('已发任务')
      this.active = this.showPublishedTasks
        ? 'publishedTasks'
        : this.showCompletedTasks
        ? 'completedTasks'
        : 'pendingTasks'
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 80vh;
}
.bg {
  background: linear-gradient(268deg, #d9ebfb 0%, #d9ebfb 0%, #f2f2f7 19.29%, #fef9f7 45.26%, #fffefe 100%);
  width: 100vw;
  height: 200vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
}

.dotClass {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  display: block;
  margin-top: 8px;
  margin-left: 5px;
  margin-bottom: 5px;
}

.notice-type {
  background-color: #ced9f5;
  color: #0b41cd;
  font-size: 12px;
  padding: 0px 5px;
  border-radius: 4px;
  min-width: 50px;
}

.notice-title {
  padding: 0px 10px;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: #0b41cd;
}

.divNormal {
  border-radius: 4px;
  background-color: #ffffff;
  border: 1px solid #d9d9d9;
  color: #8c8c8c;
  font-size: 14px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  margin-bottom: 10px;
}

.divActive {
  border-radius: 4px;
  background-color: #0b41cd;
  border: 1px solid #0b41cd;
  color: #ffffff;
  font-size: 14px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  margin-bottom: 10px;
}

/deep/.van-tabs__nav {
  background: transparent;
}
/deep/.van-tabs--line .van-tabs__wrap {
  width: 80%;
  padding-top: 5px;
  margin-left: 10%;
}
/deep/.van-tab__text--ellipsis {
  line-height: 1.75;
}
/deep/.van-tab {
  flex: 0.33;
  font-size: 16px;
  &.van-tab--active {
    font-size: 18px;
    span {
      font-weight: bold;
    }
  }
}
.empty {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 26px;
  transform: translateY(40vh);
  color: #969799;
}
.collapse {
  .van-collapse-item {
    align-items: center;
    margin-bottom: 12px;
    border-radius: 8px;
    box-shadow: 2px 2px 2px #ebedf0, 2px -2px 2px #ebedf0, -2px 2px 2px #ebedf0, -2px -2px 2px #ebedf0;
    background: linear-gradient(276deg, #d9ebfb, #f2f2f7, #fef9f7, #fffefe) !important;
    /deep/.van-collapse-item__content {
      border-radius: 0 0 8px 8px;
    }
    .card-line {
      font-size: 12px;
      font-weight: 400;
      margin-bottom: 16px;
      display: flex;
      .label {
        color: #8c8c8c;
        width: 50px;
        min-width: 50px;
      }
      .text {
        color: #262626;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
    /deep/.van-cell--clickable:active {
      background-color: transparent;
    }
  }
}

.name {
  font-size: 14px;
  font-weight: 500;
  color: #262626 !important;
}
.card-text {
  margin-left: auto;
  color: #8c8c8c;
  font-size: 12px;
  font-weight: 400;
}

.menu-icon {
  color: #0b41cd;
  margin-right: 8px;
}
.header{
  position: absolute;
  top:0;
  left: 0;
  z-index:1
}
.header {
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 52px;}
.head-arrow {
    height: 52px;
    align-items: center;
    display: flex;
    position: absolute;
    left: 16px;
  }
</style>
